import { useEffect, useState } from "react";

export default function LiveClock({ testId = "live-clock" }) {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const time = new Intl.DateTimeFormat("en-IN", {
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true, timeZone: "Asia/Kolkata",
  }).format(now);
  const date = new Intl.DateTimeFormat("en-IN", {
    day: "2-digit", month: "short", year: "numeric", timeZone: "Asia/Kolkata",
  }).format(now);
  return (
    <div className="flex items-center gap-2" data-testid={testId}>
      <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" />
      <span className="tnum text-[11px] text-zinc-500 tracking-wide whitespace-nowrap">{date} · {time} IST</span>
    </div>
  );
}
